// 

import React, { useEffect, useState, useContext } from "react";
import "./ClientEnquiryDetails.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { UserContext } from "../UserContext";
import { Snackbar, Alert, Button } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const ClientEnquiryDetails = () => {
  const [isUsingSoftware, setIsUsingSoftware] = useState("");
  const [isUsingService, setIsUsingService] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const { id } = useParams();
  const [employees, setEmployees] = useState([]);
  const [product, setProduct] = useState([]);
  const [service, setServices] = useState([]);
  const [selectedAssignedTo, setSelectedAssignedTo] = useState(null); // State to track selected assigned_to
  const { user_id, role } = useContext(UserContext);
  const [messages, setMessages] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  console.log(enquiry, "==========enquiry")


  console.log(role, "roleeeeee");
  console.log(id, "<------------id")
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await fetch("/api/employees");
        const data = await response.json();
        setEmployees(data);
      } catch (error) {
        console.error("Error fetching employees:", error);
        setMessages([
          ...messages,
          { type: "danger", text: "Error fetching employees." },
        ]);
      }
    };
    const fetchProducts = async () => {
      try {
        const response = await fetch("api/products/");
        const data = await response.json();
        setProduct(data);
      } catch (error) {
        setMessages([
          ...messages,
          { type: "danger", text: "Error fetching employees." },
        ]);
      }
    };
    const fetchServices = async () => {
      try {
        const response = await fetch("api/services/");
        const data = await response.json();
        setServices(data);
      } catch (error) {
        setMessages([
          ...messages,
          { type: "danger", text: "Error fetching employees." },
        ]);
      }
    };

    fetchEmployees();
    fetchProducts();
    fetchServices();

  }, []);

  useEffect(() => {
    const fetchEnquiryDetails = async () => {
      try {
        const response = await axios.get(`/api/client-enquiry/${id}/`);
        setEnquiry(response.data);
        setLoading(false);
  
        // Set the initial radio button values based on product and service data
        setIsUsingSoftware(response.data.product_details?.length > 0 ? "Yes" : "No");
        setIsUsingService(response.data.service_details?.length > 0 ? "Yes" : "No");
  
        // Set selected assigned_to
        setSelectedAssignedTo(response.data.assigned_to?.id || null);
      } catch (err) {
        setError(`Error: ${err.message}`);
        setLoading(false);
      }
    };
  
    fetchEnquiryDetails();
  }, [id]);
  


  // useEffect(() => {
  //   const fetchEnquiryDetails = async () => {
  //     try {
  //       const response = await axios.get(`/api/client-enquiry/${id}/`);
  //       console.log(response);
  //       setEnquiry(response.data);
  //       setLoading(false);
  //       setSelectedAssignedTo(response.data.assigned_to?.id || null); // Initialize selected assigned_to
  //     } catch (err) {
  //       setError(`Error: ${err.message}`);
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchEnquiryDetails();
  // }, [id]);

  const handleServiceRadioButtonChange = (e) => {
    const value = e.target.value;
    setIsUsingService(value);

  };
  const handleRadioButtonChange = (e) => {
    const value = e.target.value;
    setIsUsingSoftware(value);

  };

 
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `/api/client-enquiry/${id}/update/?user_id=${user_id}`,
        {
          mobile_number: enquiry.mobile_number,
          currently_using_software: enquiry.currently_using_software,
          employee_strength: enquiry.employee_strength,
          demands: enquiry.demands,
          needs: enquiry.needs,
          feedback: enquiry.feedback,
          items_required: enquiry.items_required,
          meeting_date: enquiry.meeting_date,
          assigned_to: selectedAssignedTo || enquiry.assigned_to.id,
          product_id: enquiry.product_id,
          service_id: enquiry.service_id,
        },
        {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );
      console.log(response.data, "<------------response");

      // Set Snackbar for success
      setSnackbarMessage("Update successful!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      setEnquiry(response.data); // Update the enquiry state with the response data
      setIsEditing(false);
    } catch (error) {
      console.error(error, "545454545454");
      setSnackbarMessage(`Error: ${error.message}`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update the state based on the input name
    if (name === "assigned_to") {
      setSelectedAssignedTo(value); // Update the selected assigned_to value
    } else if (name === "product_id" || name === "service_id") {
      // Convert the multiple select values to an array
      const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
      setEnquiry((prevEnquiry) => ({ ...prevEnquiry, [name]: selectedValues }));
    } else {
      setEnquiry((prevEnquiry) => ({ ...prevEnquiry, [name]: value }));
    }
  };

  const formatMeetingDateTime = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // Change to false for 24-hour format
    };
    return new Date(dateString).toLocaleString(undefined, options);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!enquiry) return <p>No data available</p>;

  const canEdit = role === "Super Admin" || role === "Admin";

  return (
    <div>
      <div className='d-flex enquiry-list1 justify-content-between align-items-center my-5'>
  <Link to="/CompanyList">
    <Button
      variant="outlined"
      color="primary"
      startIcon={<ArrowBackIcon />}
    >
      Back
    </Button>
  </Link>
  <h1 className="text-center mx-auto">Client Enquiry Details</h1>
 
</div>
      <section className="enquiry-details" >
        <div className="enquiry-header" >
          <div className="button-container">
            <Link
              to={`/timeline/${enquiry.id}/${enquiry.company_id}`}
              className="view-enquiry-history-link"
            >
              Enquiry History
            </Link>
            {canEdit && (
              <button
                className="editbtn"
                onClick={() => setIsEditing(!isEditing)}
              >
                {isEditing ? "Cancel" : "Edit"}
              </button>
            )}
          </div>
        </div>

        <div className="details-group">
          <div className="details-item">
            <h3>Company Name:</h3>
            <p>{enquiry.company_name}</p>
          </div>
          <div className="details-item">
            <h3>Company Type:</h3>
            <p>{enquiry.company_type}</p>
          </div>
          <div className="details-item">
            <h3>Company Location:</h3>
            <p>{enquiry.company_location}</p>
          </div>
          <div className="details-item">
            <h3>Contact Person:</h3>
            <p>{enquiry.contact_person}</p>
          </div>
          {isEditing ? (
            <form onSubmit={handleUpdate}>
              <div className="details-group">
                <div className="details-item">
                  <h3>Mobile Number:</h3>
                  <input
                    type="text"
                    name="mobile_number"
                    value={enquiry.mobile_number}
                    onChange={handleChange}
                    className="detail-input"
                  />
                </div>
                <div className="details-item">
                  <h3>Currently Using Software:</h3>
                  <select
                    id="currently_using_software"
                    name="currently_using_software"
                    value={enquiry.currently_using_software}
                    onChange={handleChange}
                    className="detail-input"
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                <div className="details-item">
                  <h3>Employee Strength:</h3>
                  <input
                    type="number"
                    name="employee_strength"
                    value={enquiry.employee_strength}
                    onChange={handleChange}
                    className="detail-input"
                  />
                </div>
                <div className="details-item">
                  <h3>Demands:</h3>
                  <textarea
                    name="demands"
                    value={enquiry.demands}
                    onChange={handleChange}
                    className="detail-textarea"
                  />
                </div>
                <div className="details-item">
                  <h3>Needs:</h3>
                  <textarea
                    name="needs"
                    value={enquiry.needs}
                    onChange={handleChange}
                    className="detail-textarea"
                  />
                </div>
                <div className="details-item">
                  <h3>Feedback:</h3>
                  <textarea
                    name="feedback"
                    value={enquiry.feedback}
                    onChange={handleChange}
                    className="detail-textarea"
                  />
                </div>
                <div className="details-item">
                  <h3>Items Required:</h3>
                  <textarea
                    name="items_required"
                    value={enquiry.items_required}
                    onChange={handleChange}
                    className="detail-textarea"
                  />
                </div>
                <div className="details-item">
                  <h3>Meeting Date and Time:</h3>
                  <input
                    type="datetime-local"
                    name="meeting_date"
                    value={enquiry.meeting_date}
                    onChange={handleChange}
                    className="detail-input"
                  />
                </div>

                {/* <div className="form-group">
  <div className="form-group-item">
    <label>Product</label>
    <div>
      <input
        type="radio"
        id="yes"
        name="currently_using_software"
        value="Yes"
        checked={isUsingSoftware === "Yes"}
        onChange={handleRadioButtonChange}
      />
      <label htmlFor="yes">Yes</label>
    </div>
    <div>
      <input
        type="radio"
        id="no"
        name="currently_using_software"
        value="No"
        checked={isUsingSoftware === "No"}
        onChange={handleRadioButtonChange}
      />
      <label htmlFor="no">No</label>
    </div>
  </div>
</div>
{
  isUsingSoftware === "Yes" && (
    <div className="form-group">
      <div className="form-group-item">
        <label htmlFor="product_id">Select Product:</label>
       
        <select
  id="product_id"
  name="product_id"
  multiple
  value={enquiry.product_id}
  onChange={handleChange}
  className="enquiry-form-input"
>
  <option value="">Select an Product</option>
  {product.map((user) => (
    <option key={user.id} value={user.id}>
      {user.product_name}
    </option>
  ))}
</select>
      </div>
    </div>
  )
}
<div className="form-group">
  <div className="form-group-item">
    <label> Service</label>
    <div>
      <input
        type="radio"
        id="yes-service"
        name="is_using_service"
        value="Yes"
        checked={isUsingService === "Yes"}
        onChange={handleServiceRadioButtonChange}
      />
      <label htmlFor="yes-service">Yes</label>
    </div>
    <div>
      <input
        type="radio"
        id="no-service"
        name="is_using_service"
        value="No"
        checked={isUsingService === "No"}
        onChange={handleServiceRadioButtonChange}
      />
      <label htmlFor="no-service">No</label>
    </div>
  </div>
</div>
{
  isUsingService === "Yes" && (
    <div className="form-group">
      <div className="form-group-item">
        <label htmlFor="service_id">Select Service:</label>
          <select
  id="service_id"
  name="service_id"
  multiple
  value={enquiry.service_id}
  onChange={handleChange}
  className="enquiry-form-input"
>
  <option value="">Select an Product</option>
  {service.map((user) => (
    <option key={user.id} value={user.id}>
      {user.service_name}
    </option>
  ))}
</select>
      </div>
    </div>
  )
} */}
                <div className="enquiry-form-container">
                  <div className="enquiry-form-box">
                  <div className="form-row">
  <div className="form-group">
    <div className="form-group-item" >
      <h3 style={{color: "#1bafbc",fontSize:"20px"}}>Product</h3>
      <div className="radio-button-group" style={{display:"flex", margin:"20px 0"}}>
        <div style={{marginRight:"20px"}}>
          <input
            type="radio"
            id="yes"
            name="currently_using_software"
            value="Yes"
            checked={isUsingSoftware === "Yes"}
            onChange={handleRadioButtonChange}
            style={{marginRight:"10px", }}
          />
          <label htmlFor="yes">Yes</label>
        </div>
        <div style={{marginRight:"20px"}}>
          <input
            type="radio"
            id="no"
            name="currently_using_software"
            value="No"
            checked={isUsingSoftware === "No"}
            onChange={handleRadioButtonChange}
            style={{marginRight:"10px",}}
          />
          <label htmlFor="no">No</label>
        </div>
      </div>
      {isUsingSoftware === "Yes" && (
        <div className="form-group">
          <div className="form-group-item">
            <label htmlFor="product_id" style={{marginBottom:"15px"}}>Select Product:</label>
            <select
              id="product_id"
              name="product_id"
              multiple
              value={enquiry.product_id}
              onChange={handleChange}
              className="enquiry-form-input"
            >
              <option value="">Select a Product</option>
              {product.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.product_name}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  </div>

  <div className="form-group">
    <div className="form-group-item">
      <h3 style={{color: "#1bafbc",fontSize:'20px'}}>Service</h3>
      <div className="radio-button-group" style={{display:"flex" ,margin:"20px 0"}}>
      <div style={{marginRight:"20px"}}>

          <input
            type="radio"
            id="yes-service"
            name="is_using_service"
            value="Yes"
            checked={isUsingService === "Yes"}
            style={{marginRight:"10px",}}

            onChange={handleServiceRadioButtonChange}
          />
          <label htmlFor="yes-service">Yes</label>
        </div>
        <div>
          <input
            type="radio"
            id="no-service"
            name="is_using_service"
            value="No"
            style={{marginRight:"10px",}}

            checked={isUsingService === "No"}
            onChange={handleServiceRadioButtonChange}
          />
          <label htmlFor="no-service">No</label>
        </div>
      </div>
      {isUsingService === "Yes" && (
        <div className="form-group">
          <div className="form-group-item">
            <label htmlFor="service_id" style={{marginBottom:"15px"}}>Select Service:</label>
            <select
              id="service_id"
              name="service_id"
              multiple
              value={enquiry.service_id}
              onChange={handleChange}
              className="enquiry-form-input"
            >
              <option value="">Select a Service</option>
              {service.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.service_name}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  </div>
</div>

                    {/* <div className="form-row">
                      <div className="form-group">
                        <div className="form-group-item">
                          <h3>Product</h3>
                          <div className="radio-button-group">
                            <div>
                              <input
                                type="radio"
                                id="yes"
                                name="currently_using_software"
                                value="Yes"
                                checked={isUsingSoftware === "Yes"}
                                onChange={handleRadioButtonChange}
                              />
                              <label htmlFor="yes">Yes</label>
                            </div>
                            <div>
                              <input
                                type="radio"
                                id="no"
                                name="currently_using_software"
                                value="No"
                                checked={isUsingSoftware === "No"}
                                onChange={handleRadioButtonChange}
                              />
                              <label htmlFor="no">No</label>
                            </div>
                          </div>
                          {isUsingSoftware === "Yes" && (
                            <div className="form-group">
                              <div className="form-group-item">
                                <label htmlFor="product_id">Select Product:</label>
                                <select
                                  id="product_id"
                                  name="product_id"
                                  multiple
                                  value={enquiry.product_id}
                                  onChange={handleChange}
                                  className="enquiry-form-input"
                                >
                                  <option value="">Select an Product</option>
                                  {product.map((user) => (
                                    <option key={user.id} value={user.id}>
                                      {user.product_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="form-group-item">
                          <h3>Service</h3>
                          <div className="radio-button-group">
                            <div>
                              <input
                                type="radio"
                                id="yes-service"
                                name="is_using_service"
                                value="Yes"
                                checked={isUsingService === "Yes"}
                                onChange={handleServiceRadioButtonChange}
                              />
                              <label htmlFor="yes-service">Yes</label>
                            </div>
                            <div>
                              <input
                                type="radio"
                                id="no-service"
                                name="is_using_service"
                                value="No"
                                checked={isUsingService === "No"}
                                onChange={handleServiceRadioButtonChange}
                              />
                              <label htmlFor="no-service">No</label>
                            </div>
                          </div>
                          {isUsingService === "Yes" && (
                            <div className="form-group">
                              <div className="form-group-item">
                                <label htmlFor="service_id">Select Service:</label>
                                <select
                                  id="service_id"
                                  name="service_id"
                                  multiple
                                  value={enquiry.service_id}
                                  onChange={handleChange}
                                  className="enquiry-form-input"
                                >
                                  <option value="">Select an Service</option>
                                  {service.map((user) => (
                                    <option key={user.id} value={user.id}>
                                      {user.service_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>


               
              </div>
              <button type="submit" className="update-btn">
                Update
              </button>
            </form>
          ) : (
            <>
              <div className="details-item">
                <h3>Mobile Number:</h3>
                <p>{enquiry.mobile_number}</p>
              </div>
              <div className="details-item">
                <h3>Currently Using Software:</h3>
                <p>{enquiry.currently_using_software || "N/A"}</p>
              </div>
              <div className="details-item">
                <h3>Employee Strength:</h3>
                <p>{enquiry.employee_strength}</p>
              </div>
              <div className="details-item">
  <h3>Products:</h3>
  <ul>
    {enquiry.product_details?.map((product) => (
      <li key={product.id}>{product.product_name}</li>
    ))}
  </ul>
</div>

<div className="details-item">
  <h3>Services:</h3>
  <ul>
    {enquiry.service_details?.map((service) => (
      <li key={service.id}>{service.service_name}</li>
    ))}
  </ul>
</div>
              <div className="details-item">
                <h3>Demands:</h3>
                <p>{enquiry.demands || "N/A"}</p>
              </div>
              <div className="details-item">
                <h3>Needs:</h3>
                <p>{enquiry.needs || "N/A"}</p>
              </div>
              <div className="details-item">
                <h3>Feedback:</h3>
                <p>{enquiry.feedback || "N/A"}</p>
              </div>
              <div className="details-item">
                <h3>Items Required:</h3>
                <p>{enquiry.items_required || "N/A"}</p>
              </div>
              <div className="details-item">
                <h3>Meeting Date:</h3>
                <p>Meeting Date: {formatMeetingDateTime(enquiry.meeting_date)}</p>
              </div>
              <div className="details-item">
                <h3>Assigned To:</h3>
                {enquiry.assigned_to && (
                  <p>
                    {enquiry.assigned_to.first_name}{" "}
                    {enquiry.assigned_to.last_name} -{enquiry.assigned_to.role}
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      </section>
      <div>
        <Button onClick={handleUpdate}></Button>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Positioning
          sx={{ "& .MuiSnackbarContent-root": { minWidth: 300 } }} // Increase size
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackbarSeverity}
            sx={{ padding: "16px", fontSize: "1.2rem" }} // Increase Alert size
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default ClientEnquiryDetails;
